export default {
  modal: 'success-modal',
  modalTitle: 'success-title',
  modalDescription: 'success-description',
  survey: 'success-survey',
  surveyTitle: 'success-survey-title',
  surveyLink: 'survey-link',
  continueButton: 'success-continue',
  createNewButton: 'success-create-new',
};
